// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'indent';

export const Component = () => (
  <path
    fill='none'
    stroke='currentColor'
    strokeLinecap='round'
    strokeLinejoin='round'
    d='m4.75 8.561 2.125-2.125L4.75 4.311m4.781-1.062h7.438M9.531 6.436h7.438M9.531 9.624h7.438M3.156 12.811H16.97M3.156 15.998H16.97M1.031 6.436h5.844'
  />
);

export const viewBox = '0 0 18 18';
